import React, { useEffect, useState } from "react";
import { Tabs, Tab, Typography, Box } from "@mui/material";
//import ActivityList from "../Activity/ActivityList";
import { fetchAllStories, fetchAllLetters } from "./adminFetchUtils";
import {  Story, Letter, Hostage } from "../types";
import StoryList from "../Hostage/StoryList";
import LetterList from "../Hostage/LetterList";

const emptyHostage: Hostage = {
  id: "",
  name: "",
  first_name: "",
  last_name: "",
  photo: "",
  age: 0,
  text: "",
  city: "",
  story: "",
  familySituation: "",
  gender: "male",
  pictures: [],
  profilePicture: "",
  isBack: false,
  is_alive: true,
  en: {
    first_name: "",
    last_name: "",
    name_with_title: "",
    text: "",
    city: ""
  },
  he: {
    first_name: "",
    last_name: "",
    name_with_title: "",
    text: "",
    city: ""
  }
};

const Admin = () => {
  const [value, setValue] = useState(0);
  //const [activities, setActivities] = useState<Activity[]>([]);
  const [stories, setStories] = useState<Story[]>([]);
  const [letters, setLetters] = useState<Letter[]>([]);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  useEffect(() => {
    const loadData = async () => {
      //const activitiesData = await fetchAllActivities();
      const storiesData = await fetchAllStories();
      const lettersData = await fetchAllLetters();

      //setActivities(activitiesData);
      setStories(storiesData);
      setLetters(lettersData);
    };

    loadData();
  }, []);

  const renderContent = () => {
    switch (value) {
      // case 0:
      //   return (
      //     <Box className="non-interactive">
      //       <ActivityList activities={activities} hostages={[]} registeredUsersMap={{}} />
      //     </Box>
      //   );
      case 0:
        return (
          <Box className="non-interactive" style={{ maxWidth: "500px" }}>
            <StoryList stories={stories} hostage={emptyHostage} onDeleteStory={() => {}} />
          </Box>
        );
      case 1:
        return (
          <Box className="non-interactive" style={{ maxWidth: "500px" }}>
            <LetterList letters={letters} hostage={emptyHostage} onDeleteLetter={() => {}} />
          </Box>
        );
      default:
        return null;
    }
  };

  return (
    <Box>
      <Tabs value={value} onChange={handleChange}>
        <Tab label="סיפורים" />
        <Tab label="מכתבים" />
      </Tabs>
      {renderContent()}
    </Box>
  );
};

export default Admin;
